import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var QUOTATION_STATUS = {
  NOT_STARTED: {
    id: 1,
    name: "Not started",
    badgeClass: "danger"
  },
  MAIL_SENT: {
    id: 2,
    name: "Mail sent",
    badgeClass: "warning"
  },
  SUPPLIERS_HAVE_REFUSED: {
    id: 3,
    name: "Suppliers refused",
    badgeClass: "danger"
  },
  SUPPLIER_HAS_APPROVED: {
    id: 4,
    name: "Supplier approved",
    badgeClass: "success"
  }
};
export default {
  name: "SourcingItemData",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    orderItem: Object
  },
  data: function data() {
    return {
      updatingQuotationStatus: {
        isConfiguring: false,
        form: {
          quotationStatus: null
        },
        isPending: false,
        cancellationToken: null
      },
      updatingComment: {
        form: {
          comment: ""
        },
        isPending: false,
        cancellationToken: null
      },
      quotationStatusList: Object.values(QUOTATION_STATUS),
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    quotationStatusClass: function quotationStatusClass() {
      var _this2 = this,
        _quotationStatus$badg;
      var quotationStatus = this.quotationStatusList.find(function (x) {
        var _this2$orderItem;
        return x.id === ((_this2$orderItem = _this2.orderItem) === null || _this2$orderItem === void 0 || (_this2$orderItem = _this2$orderItem.sourcingData) === null || _this2$orderItem === void 0 ? void 0 : _this2$orderItem.quotationStatus);
      });
      return (_quotationStatus$badg = quotationStatus === null || quotationStatus === void 0 ? void 0 : quotationStatus.badgeClass) !== null && _quotationStatus$badg !== void 0 ? _quotationStatus$badg : "neutral";
    },
    quotationStatusLabel: function quotationStatusLabel() {
      var _this3 = this,
        _quotationStatus$name;
      var quotationStatus = this.quotationStatusList.find(function (x) {
        var _this3$orderItem;
        return x.id === ((_this3$orderItem = _this3.orderItem) === null || _this3$orderItem === void 0 || (_this3$orderItem = _this3$orderItem.sourcingData) === null || _this3$orderItem === void 0 ? void 0 : _this3$orderItem.quotationStatus);
      });
      return (_quotationStatus$name = quotationStatus === null || quotationStatus === void 0 ? void 0 : quotationStatus.name) !== null && _quotationStatus$name !== void 0 ? _quotationStatus$name : "Undefined";
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this4$orderItem;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this4.updatingComment.form.comment = (_this4$orderItem = _this4.orderItem) === null || _this4$orderItem === void 0 || (_this4$orderItem = _this4$orderItem.sourcingData) === null || _this4$orderItem === void 0 ? void 0 : _this4$orderItem.comment;
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    startEditQuotationStatus: function startEditQuotationStatus() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this5$orderItem$sour;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.updatingQuotationStatus.form.quotationStatus = (_this5$orderItem$sour = _this5.orderItem.sourcingData) === null || _this5$orderItem$sour === void 0 ? void 0 : _this5$orderItem$sour.quotationStatus;
              _this5.updatingQuotationStatus.isConfiguring = true;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    udpateQuotationStatus: function udpateQuotationStatus() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this6$updatingQuotat;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.updatingQuotationStatus.isPending = true;
              (_this6$updatingQuotat = _this6.updatingQuotationStatus.cancellationToken) === null || _this6$updatingQuotat === void 0 || _this6$updatingQuotat.cancel();
              _this6.updatingQuotationStatus.cancellationToken = axios.CancelToken.source();
              data = {
                itemId: _this6.orderItem.id_item,
                quotationStatus: _this6.updatingQuotationStatus.form.quotationStatus
              };
              _this = _this6;
              _context3.next = 7;
              return request("/v1/sourcing/quotation-status", "put", data, true, "api", null, _this.updatingQuotationStatus.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingQuotationStatus.isPending = false;
                  var errorData = getErrorData(e, "Unable to update status", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this6.updatingQuotationStatus.isPending = false;
              _this6.updatingQuotationStatus.isConfiguring = false;
              _this6.$emit("quotationStatusUpdated", {
                orderId: _this6.orderItem.id_order,
                itemId: _this6.orderItem.id_item,
                newQuotationStatus: data.quotationStatus
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    udpateComment: function udpateComment() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this7$updatingCommen;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.updatingComment.isPending = true;
              (_this7$updatingCommen = _this7.updatingComment.cancellationToken) === null || _this7$updatingCommen === void 0 || _this7$updatingCommen.cancel();
              _this7.updatingComment.cancellationToken = axios.CancelToken.source();
              data = {
                itemId: _this7.orderItem.id_item,
                comment: _this7.updatingComment.form.comment
              };
              _this = _this7;
              _context4.next = 7;
              return request("/v1/sourcing/comment", "put", data, true, "api", null, _this.updatingComment.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingComment.isPending = false;
                  var errorData = getErrorData(e, "Unable to update comment", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this7.updatingComment.isPending = false;
              _this7.$emit("commentUpdated", {
                orderId: _this7.orderItem.id_order,
                itemId: _this7.orderItem.id_item,
                newComment: data.comment
              });
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  },
  watch: {
    "orderItem.sourcingData": function orderItemSourcingData(newVal, oldVal) {
      var _newVal$sourcingData;
      this.updatingComment.form.comment = (_newVal$sourcingData = newVal.sourcingData) === null || _newVal$sourcingData === void 0 ? void 0 : _newVal$sourcingData.comment;
    }
  }
};